import request from "./request";
import { AddonUsageResponse } from "../shared/api-types";

export type { AddonUsageResponse };

export const getCompanyCourseUsage = async (crewId: number): Promise<AddonUsageResponse> => {
  return await request(`/addons/${crewId}/usage`);
};
